import * as React from "react";
import { forwardRef } from "react";
const SvgDashboard = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 22 19",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M1.8 1.8c-.5.4-.8 1.1-.8 1.8V15a2.6 2.6 0 0 0 2.6 2.6h2.6A2.6 2.6 0 0 0 8.8 15V3.6A2.6 2.6 0 0 0 6.2 1H3.6c-.7 0-1.4.3-1.8.8ZM13.7 1.8c-.5.4-.8 1.1-.8 1.8v1.6a2.6 2.6 0 0 0 2.6 2.6h2.9A2.6 2.6 0 0 0 21 5.2V3.6A2.6 2.6 0 0 0 18.4 1h-2.9c-.7 0-1.3.3-1.8.8ZM13.7 11.7c-.5.5-.8 1.2-.8 1.9V15a2.6 2.6 0 0 0 2.6 2.6h2.9A2.6 2.6 0 0 0 21 15v-1.4a2.6 2.6 0 0 0-2.6-2.6h-2.9c-.7 0-1.3.3-1.8.7Z",
	stroke: "currentColor",
	fill: "none",
	strokeWidth: 1.5
}));
const ForwardRef = forwardRef(SvgDashboard);
export default ForwardRef;
